












import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';

@Component({})
export default class TextField extends Vue {
  private tooltip: string = '';
  @Prop()
  private value!: string | null;
  @Prop({default: null})
  private appendClass!: string | JSON | null;
  @Prop({default: false})
  private disabled!: boolean;
  @Prop({default: false})
  private alert!: boolean;
  @Prop({default: true})
  private defaultStyle!: boolean;

  private style(): any {
    const style: any = {
      disabled: this.disabled,
      alert: this.alert,
      textfield: this.defaultStyle,
    };
    if (!this.appendClass) {
      return style;
    }
    if (typeof this.appendClass === 'string') {
      style[this.appendClass] = true;
      return style;
    }
    return Object.assign(style, this.appendClass);
  }

  @Emit('input')
  private update(event: Event): string | null {
    this.alert = false;
    const target = event.target as HTMLInputElement;

    if (!target.validationMessage) {
      return target.value;
    }

    this.alert = true;
    this.tooltip = target.validationMessage;

    return target.value;
  }

  @Emit('changed')
  private changed(event: Event): Event {
    return event;
  }
}
